module.exports = __webpack_public_path__ + "media/newstyle/images/icon-play-two-20948d4591d7e0019d5cb0ce81cffb7f.svg";